module.exports = __webpack_public_path__ + "static/media/vnda11.e403721a.png";